function i(o, t, f) {
  var r;
  if (o instanceof Element)
    return [o];
  if (typeof o == "string") {
    let s = document;
    const n = (r = void 0) !== null && r !== void 0 ? r : s.querySelectorAll(o);
    return n ? Array.from(n) : [];
  }
  return Array.from(o);
}
export {
  i as resolveElements
};
